/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';

// material
import { useTheme, styled } from '@material-ui/core/styles';
import { Card, CardHeader } from '@material-ui/core';
// utils
import { fNumber } from '../../../utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';
import dashboardService from './DashboardService';
import TokenDecoder from '../../../helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

export default function AppCurrentVisits() {

  const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

  const [data, setData] = useState([]);

  useEffect(() => {
    trackPromise(GetData());
  }, [])


  async function GetData() {
    const response = await dashboardService.GetProductDetailsForPieChartDashboard(OpID);
    setData(response)
  }

  const theme = useTheme();

  let chartData = []
  data.forEach(element => {
    chartData.push(element.quantity)
  });

  let labelData = []
  data.forEach(element => {
    labelData.push(element.productName)
  });

  let randomColorGenerator = function () {
    return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
  };

  let colorArray = []
  chartData.forEach(element => {
    colorArray.push(randomColorGenerator())
  });

  const chartOptions = merge(BaseOptionChart(), {
    colors: colorArray,
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: false
        }
      }
    },
    labels: labelData,
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
    },
    stroke: { width: 2, colors: [theme.palette.background.paper] },
    dataLabels: { enabled: true, dropShadow: { enabled: false } },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `#${seriesName}`
        }
      }
    },
    plotOptions: {
      pie: { donut: { labels: { show: false } } }
    }
  });

  return (
    <>
      <LoadingComponent />
      <Card>
        <CardHeader title="High Demand Products" />
        <ChartWrapperStyle dir="ltr">
          <ReactApexChart type="pie" series={chartData} options={chartOptions} height={400} />
        </ChartWrapperStyle>
      </Card>
    </>
  );
}
